module.exports = __webpack_public_path__ + "static/media/zhinengjiesuanxitong.e9cad9af.jpg";